var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky"},[_c('img',{staticClass:"Internet",attrs:{"src":require("@/assets/navbar/back_white.png"),"alt":""},on:{"click":_vm.handleBlack}}),_c('img',{staticClass:"Internet",attrs:{"src":require("@/assets/navbar/Internet_white.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }